import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { browsingDomainStore } from '../../store';
import { getSitesByIds } from './get-sites-by-ids';
export const getAllSites = () => {
    const siteIds = getFetchedDataPayload(browsingDomainStore.data.allSiteIds);
    return siteIds ? getSitesByIds(siteIds) : undefined;
};
